import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logistics-features',
  templateUrl: './logistics-features.component.html',
  styleUrls: ['./logistics-features.component.scss']
})
export class LogisticsFeaturesComponent implements OnInit {
  features: Array<{ icon: string, title: string, description: string }> = [
    { icon: "assets/svgs/cod_v1/feature_same_day_delivery.svg", title: "Same Day Delivery", description: "Experience fast and reliable service with Same Day Delivery, ensuring happy customers and seamless operations." },
    { icon: "assets/svgs/cod_v1/feature_nationalwide_coverage.svg", title: "Nationwide Coverage", description: "We cover the entire country, ensuring your items reach their destination hassle-free." },
    { icon: "assets/svgs/cod_v1/feature_flexible_pricing.svg", title: "Flexible Pricing", description: "Adjust costs to fit your budget with customizable options and personalized payment plans." },
    { icon: "assets/svgs/cod_v1/feature_easy_instalment.svg", title: "Easy Integration", description: "Instantly integrate our user-friendly APIs with any e-commerce platform for a hassle-free setup." },
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
